import script from "./orderSubMit.vue?vue&type=script&setup=true&lang=js"
export * from "./orderSubMit.vue?vue&type=script&setup=true&lang=js"

import "./orderSubMit.vue?vue&type=style&index=0&id=4d3ab58c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3ab58c"]])

export default __exports__